import { INSURANCE_COMPANIES_PARTNER_FILTER_EVENTS } from './global-events';

export const insuranceCompaniesPartnerFilterOptions = [
  {
    id: 'all',
    name: 'Вся система',
    event: INSURANCE_COMPANIES_PARTNER_FILTER_EVENTS.INSURANCE_COMPANIES_PARTNER_FILTER_ALL,
    options: {
      type: 'checkbox',
      activeFilter: false,
    }
  },
];
